import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { useEffect, useCallback } from "react";
import { logoutUserWithoutToken } from "../../slices/session";
import { bootstrapResponseFailed, getCurrentUser } from "../../api/session";
import { useSelector } from "react-redux";
const AuthVerify = () => {
  let location = useLocation();
  const dispatch = useDispatch();
  const accessToken = useSelector((state) => state.session.accessToken);
  const loading = useSelector((state) => state.session.loading);

  const checkAccessToken = useCallback(async () => {
    if (!accessToken) return;
    try {
      const response = await getCurrentUser(accessToken);
      if (!bootstrapResponseFailed(response)) return;

      const status = response?.status ?? 0;
      // Invalid/expired token or account gates — not company bootstrap (422).
      if (status === 401) {
        dispatch(logoutUserWithoutToken());
      }
    } catch (err) {
      console.error("Error", err);
    }
  }, [accessToken, dispatch]);

  useEffect(() => {
    if (!loading) {
      checkAccessToken();
    }
  }, [location.pathname, loading, checkAccessToken]);
};

export default AuthVerify;
